import React, { useState } from 'react';
import CustomDialog from '../shared/Overlays/CustomDialog';
import { AutoComplete } from 'primereact/autocomplete';
import { PrivateRoutes } from '../routes/allRoutes';
import { useMemo } from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const GlobalSearch = ({ visible, setVisible }) => {
    const history = useHistory();
    let searchItems = useMemo(() => flattenRoutes(PrivateRoutes), [PrivateRoutes]);

    const [value, setValue] = useState('');
    const [items, setItems] = useState([]);

    const search = (event) => {
        let query = event.query;
        const filteredRoutes = searchItems.filter((r) => r.name.toLowerCase().includes(query.toLowerCase()));
        setItems(filteredRoutes);
    };

    useEffect(() => {
        if (value?.path) {
            onSelect(value?.path);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    function onSelect(path, e, blank) {
        if (blank) {
            e.stopPropagation();
            window.open('/#' + path, '_blank');
        } else {
            history.push(path);
        }
        setTimeout(() => {
            setVisible(false);
        }, 400);
        setTimeout(() => {
            setValue('');
        }, 500);
    }

    function flattenRoutes(routes, parentPath = '', parentNames = []) {
        let flatRoutes = [];

        routes.forEach((route) => {
            const fullPath = `${parentPath}${route.path}`;
            const namePath = [...parentNames, route.name];

            if (!fullPath.includes(':')) {
                flatRoutes.push({
                    name: route.name,
                    path: fullPath,
                    breadcrumb: namePath.join(' > '),
                });
            }
            if (route.items) {
                flatRoutes = flatRoutes.concat(flattenRoutes(route.items, fullPath, namePath));
            }
        });
        return flatRoutes;
    }

    return (
        <>
            <CustomDialog title="Where do you want to go?" visible={visible} onHide={() => setVisible(false)} position="top" width="50vw">
                <span className="p-input-icon-right w-full">
                    <AutoComplete
                        field="name"
                        value={value}
                        suggestions={items}
                        completeMethod={search}
                        onChange={(e) => setValue(e.value)}
                        className="w-full"
                        inputClassName="w-full"
                        showEmptyMessage={true}
                        itemTemplate={(item) => (
                            <div className="flex justify-content-between">
                                <div>
                                    <span className="text-lg text-900">{item.name}</span>
                                    <br />
                                    {item.breadcrumb.includes('>') && <span className="text-sm text-600">{item.breadcrumb}</span>}
                                </div>
                                <i
                                    style={{ zIndex: '999' }}
                                    onClick={(e) => onSelect(item.path, e, true)}
                                    className="my-auto pi pi-external-link px-3 py-2 hover:text-blue-600"
                                ></i>
                            </div>
                        )}
                        autoFocus
                    />
                    <i className="pi pi-search" />
                </span>
            </CustomDialog>
        </>
    );
};

export default GlobalSearch;
